import _ from 'lodash';

import { consumer } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';
import protos from 'utils/consumerProto';

const { ConsumerPageRequest, ConsumerPageWidgetDataRequest } = protos;

export type PageTypeData =
  | { type: 'CHASE_ULTIMATE_REWARDS'; productId?: string }
  | { type: 'EXPLORETOCK' };

export function consumerPageStoreInit(): BaseTockAction {
  return {
    type: AppConstants.CONSUMER_PAGE_SEARCH_INIT,
  };
}

export function searchPage(
  slug: string,
  type: PageTypeData,
  isPreview = false,
  selectedMetroAreaId?: number,
  shouldCache?: boolean
): ApiAction {
  const postProto = '/consumer/page';
  const request = ConsumerPageRequest.fromObject({
    slug,
    type: type.type,
    isPreview: isPreview ? 1 : 0,
    pageContext: {
      chaseProductId: type.type === 'CHASE_ULTIMATE_REWARDS' ? type.productId : undefined,
      selectedMetroAreaId,
    },
  });

  return {
    TockApi: {
      postProto,
      type: AppConstants.CONSUMER_PAGE_SEARCH,
      request,
      cacheOptions: shouldCache
        ? {
            enableCache: true,
            maxAge: 60 * 1000,
          }
        : undefined,
      onError: _.noop, // Let caller handle errors
    },
  };
}

export function fetchMoreWidgetData(
  slug: string,
  type: consumer.ConsumerPageType,
  widgetId: number,
  start: number,
  shouldCache?: boolean,
  selectedMetroAreaId?: number
) {
  const postProto = '/consumer/page/widget';
  const request = ConsumerPageWidgetDataRequest.fromObject({
    slug,
    type,
    widgetId,
    start,
    pageContext: {
      selectedMetroAreaId,
    },
  });

  return {
    TockApi: {
      postProto,
      type: AppConstants.CONSUMER_PAGE_WIDGET_DATA_FETCH,
      request,
      cacheOptions: shouldCache
        ? {
            enableCache: true,
            maxAge: 60 * 1000,
          }
        : undefined,
      onError: _.noop, // Let caller handle errors
    },
  };
}

export function fetchMoreWidgetDataV2(
  slug: string,
  type: consumer.ConsumerPageType,
  widgetId: number,
  start: number,
  shouldCache?: boolean,
  selectedMetroAreaId?: number
) {
  const postProto = '/consumer/page/widget/v2';
  const request = ConsumerPageWidgetDataRequest.fromObject({
    slug,
    type,
    widgetId,
    start,
    pageContext: {
      selectedMetroAreaId,
    },
  });

  return {
    TockApi: {
      postProto,
      type: AppConstants.CONSUMER_PAGE_WIDGET_DATA_FETCH_V2,
      request,
      cacheOptions: shouldCache
        ? {
            enableCache: true,
            maxAge: 60 * 1000,
          }
        : undefined,
      onError: _.noop, // Let caller handle errors
    },
  };
}
